<template>
	<loading :full-page="true"></loading>
</template>

<script>

import { mapGetters, mapState } from 'vuex';
import getMeta from '@/utils/getMeta';
import { getDefaults } from '@/utils/colors';

export default {

	name: 'SwitchAccountPage',

	computed: {
		...mapGetters([ 'hasIntended', 'intendedRoute' ]),

		...mapState({
			accountsById: state => state.auth.accountsById,
		}),
	},

	beforeRouteEnter(to, from, next) {
		next(vm => {
			const intendedOverride = getMeta(from, 'intendedOverride', null);

			if (from && !!intendedOverride) {
				const path = typeof intendedOverride === 'string' ? intendedOverride : from.fullPath;
				vm.$store.dispatch('setIntended', { path, accountId: to.params.id });
			}
			vm.changeAccounts();
		});
	},

	methods: {

		async changeAccounts() {
			const result = await this.$store.dispatch('switchAccount', this.$route.params.id);
			if (!result) {
				this.$store.dispatch('addToast', { message: 'Unable to switch to that account', type: 'bad' });
			}

			const newAccount = this.accountsById[this.$route.params.id] || {};

			this.$root.$emit('colors', newAccount);

			this.$store.dispatch('closeAccountMenu');

			if (this.hasIntended && this.intendedRoute.accountId == this.$route.params.id || !this.intendedRoute.accountId) {
				this.$router.replace(this.intendedRoute.path);
				this.$store.dispatch('closeMenu');
				this.$store.dispatch('clearIntended');
				return;
			}

			this.$nextTick(() => {
				// Regardless of success we should take them to the dashboard
				this.$store.dispatch('closeMenu');
				this.$router.replace(newAccount.master ? '/admin/accounts' : '/dashboard');
			});

		},

	},
};

</script>
